import React, { useEffect } from 'react';
import queryString from 'query-string';
import axios from 'axios';

const { REACT_APP_MY_LOBBY_BACKEND_URL } = process.env;

export const InvitationStatus = (props) => {
  const parsedQueryString = queryString.parse(window.location.search);
  const reservationId = parseInt(parsedQueryString.reservationId, 10);
  const inviteeEmail = parsedQueryString.inviteeEmail;
  const status = parsedQueryString.status;
  console.log('====================================');
  console.log(reservationId);
  console.log('====================================');

  useEffect(() => {
    props.hideLoader();
    const data = axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/rooms_reservations/invitationstatus`, {
      reservationId: reservationId,
      inviteeEmail: inviteeEmail,
      status: status,
    });
    console.log('====================================');
    console.log(data);
    console.log('====================================');
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="container max-w-xs mx-auto">
      <div className="full-window columns-1 align-top px-8 pt-6 pd-8 mb-4">
        <div className="grid grid-rows-1 mt-20">
          <h1 className="text-center text-black font-black">Thanks for Responding</h1>
          <p className="text-center text-black mt-20">We will update the reservation with your status</p>
        </div>
      </div>
    </div>
  );
};
